import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet'
import { checkIconW, removeIcon } from '../../resources/images'
import * as UIActions from '../../actions/uiAction';
import * as ProductActions from '../../actions/productAction';

class MyCart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            yearOptions: [],
            additionalInfo: {
                studyAt: '',
                AMAME: '',
                schoolLocation: '',
                schoolName: '',
                graduateYear: '',
                testDate: '',
            },
            withTestDate: false,
            acceptTNC: false,
        }
    }

    componentDidMount() {
        let yearOptions = []

        for (var i = 1978; i <= 2025; i++) {
            yearOptions.push(i);
        }

        this.setState({ yearOptions })
    }

    delProduct = (i) => {
        const newProductList = [...this.props.ProductStore.productList]
        newProductList.splice(i, 1);

        this.props.updateProductList(newProductList)
    }

    onNavigate = (type) => {
        if (type === "login") {
            this.props.updateNavToCart(true)
            this.props.history.push('/login')
        }
        if (type === 'signup') {
            this.props.updateNavToCart(true)
            this.props.history.push('/signup')
        }
    }

    toogleBtn = (type) => {
        this.setState((prevState) => ({
            [type]: !prevState[type]
        }))
    }


    render() {
        const { yearOptions, acceptTNC, withTestDate } = this.state
        const {
            UserStore: {
                userInfo: {
                    firstName,
                    email
                }
            },
            ProductStore: {
                productList,
                grandTotal
            }
        } = this.props
        const loggedIn = !!email && email.length
        return (
            <Fragment>
                <Helmet>
                    <title>QBank Sign Up Page</title>
                    <meta name="description" content="QBank Sign Up Page allowed new user to create an QBank account and the benific to be a QBank user." />
                </Helmet>
                <div className="cartPage">
                    <div className="qbRow">
                        {loggedIn ?
                            <div className="qbCard largeCont">
                                <div className="fTitle">ACCOUNT INFORMATION</div>
                                <div className="qbForm">
                                    <div className="fBody">Hi there, {firstName}</div>
                                    <div className="itemCont">
                                        <div className="fLabel disabled">Email</div>
                                        <div className="qbInput disabled">test@email.com</div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="itemCont">
                                            <div className="fLabel disabled">First Name</div>
                                            <div className="qbInput disabled">test@email.com</div>
                                        </div>
                                        <div className="itemCont">
                                            <div className="fLabel disabled">Last Name</div>
                                            <div className="qbInput disabled">test@email.com</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="fTitle">ADDITIONAL INFORMATION</div>
                                <div className="qbForm">
                                    <div className="fBody">This will help us personalize your prep</div>
                                    <div className="itemCont">
                                        <div className="fLabel">Where did you study medicine?</div>
                                        <select id="studyAt" className="qbSelect">
                                            <option value="US">I graduated/will graduate from a US Medical School</option>
                                            <option value="NONUS">I graduated/will graduate from a NON US Medical School</option>
                                        </select>
                                    </div>
                                    <div className="itemCont">
                                        <div className="fLabel">AMA ME # (optional)</div>
                                        <input
                                            id="AMAME"
                                            type="text"
                                            className="qbInput"
                                        />
                                    </div>
                                    <div className="qbRow">
                                        <div className="itemCont">
                                            <div className="fLabel">School / Alma Mater Location</div>
                                            <input
                                                id="schoolLocation"
                                                type="text"
                                                className="qbInput"
                                            />
                                        </div>
                                        <div className="itemCont">
                                            <div className="fLabel">School / Alma Mater Name</div>
                                            <input
                                                id="schoolName"
                                                type="text"
                                                className="qbInput"
                                            />
                                        </div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="itemCont">
                                            <div className="fLabel">Graduation Year</div>
                                            <select id="graduateYear" className="qbSelect">
                                                {yearOptions.map((l, idx) =>
                                                    <option value={l} key={idx}>{l}</option>
                                                )}
                                            </select>
                                        </div>
                                        <div className="itemCont">
                                            <div className="fLabel">When's Your Test?</div>
                                            <select id="testDate" className="qbSelect">
                                                <option value="Within 2 weeks">Within 2 weeks</option>
                                                <option value="Within a month">Within a month</option>
                                                <option value="Within 3 month">Within 3 month</option>
                                                <option value="Within 6 month">Within 6 month</option>
                                                <option value="Within a year or more">Within a year or more</option>
                                            </select>
                                            <div className="checkBox">
                                                <div className={withTestDate ? "iconCont active" : "iconCont"} onClick={() => this.toogleBtn('withTestDate')}>
                                                    <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                                </div>
                                                <div className="fLabel">I do not know my test date</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : <div className="qbCard largeCont">
                                <div className="fTitle">ARE YOU AN QBANK USER YET?</div>
                                <div className="loginCont">
                                    <div className="fBody">Let QBank know you more by login / signup a QBank account</div>
                                    <div className="loginBox">
                                        <div className="itemCont">
                                            <div className="fLabel">Existing QBank User</div>
                                            <div className="qbBtn" onClick={() => this.onNavigate('login')}>LOGIN</div>
                                        </div>
                                        <div className="itemCont">
                                            <div className="fLabel">New User</div>
                                            <div className="qbBtn" onClick={() => this.onNavigate('signup')}>SIGNUP</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="qbCard">
                            <div className="summaryBox">
                                <div className="fTitle">ORDER SUMMARY</div>
                                <div className="orderBox">
                                    {productList && productList.length ?
                                        <Fragment>
                                            {productList.map((l, idx) =>
                                                <Fragment key={idx}>
                                                    <div className="itemCont">
                                                        <img src={removeIcon} alt="Remove Icon" className="qbIcon" onClick={() => this.delProduct(idx)} />
                                                        <div className="itemLabel">{l.planName} - {l.period}</div>
                                                        <div className="itemLabel bold">${l.price}</div>
                                                    </div>
                                                    <div className="dateCont">
                                                        <div className="itemLabel">Select Start Date</div>
                                                        <input
                                                            id="startDate"
                                                            type="date"
                                                            className="qbInput"
                                                        />
                                                    </div>
                                                </Fragment>
                                            )}
                                            <div className="promoCont">
                                                <input
                                                    type="text"
                                                    className="qbInput"
                                                    placeholder="Promo Code"
                                                />
                                                <div className="qbBtn">APPLY</div>
                                            </div>
                                            <div className="totalCont">
                                                <div className="fTitle large">TOTAL</div>
                                                <div className="fTitle">${grandTotal}</div>
                                            </div>
                                            <div className="actionCont">
                                                <div className="checkBox">
                                                    <div className={acceptTNC ? "iconCont active" : "iconCont"} onClick={() => this.toogleBtn('acceptTNC')}>
                                                        <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                                    </div>
                                                    <div className="fLabel">I accept the Terms and Conditions and Privacy Policy</div>
                                                </div>
                                                <div className="qbBtn border" onClick={() => this.props.history.push('/pricing')}>CONTINUE SHOPPING</div>
                                                <div className="qbBtn">PLACE ORDER</div>
                                            </div>
                                        </Fragment>
                                        : <div className="actionCont">
                                            <div className="fBody">Your cart is empty</div>
                                            <div className="qbBtn" onClick={() => this.props.history.push('/')}>VIEW PRODUCT</div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ UserStore, ProductStore }) => ({
    UserStore,
    ProductStore
});

const mapDispatchToProps = (dispatch) => ({
    addError: (msg) => dispatch(UIActions.addError(msg)),
    showSuccess: (msg) => dispatch(UIActions.showSuccess(msg)),
    updateNavToCart: (data) => dispatch(UIActions.updateNavToCart(data)),
    updateProductList: (data) => dispatch(ProductActions.updateProductList(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyCart));


// WEBPACK FOOTER //
// ./src/Components/cart/Cart.js